import parse from 'html-react-parser'
import { FC } from 'react'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'

import { ASSETS, defaultCardImage } from '../../../constants'
import { useI18n } from '../../../hooks'
import { useAppSelector } from '../../../store'
import { ProductWithVariants } from '../../../types'
import { getAmountWithCurrency } from '../../../utils'
import { random } from '../../../utils/random'
import Image from '../../atoms/images/image'

import './index.css'

type FacultyDealsCardProps = {
  product: ProductWithVariants
}
type FacultyDealsProps = {
  products: ProductWithVariants[]
}

const FacultyDealsCard: FC<FacultyDealsCardProps> = ({ product }) => {
  const { mediaUrls, name, asLowAs, description } = product
  const history = useHistory()

  const productImage = mediaUrls
    ? mediaUrls.find(({ displayIntent }) => displayIntent === 'card_image' || displayIntent === 'CardImage') || defaultCardImage
    : defaultCardImage
  const toPath = `/products/${product.productId}`

  const { t } = useI18n()
  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const { locale } = settings
  return (
    <div className="faculty-deals-card">
      <Image
        className="faculty-deals-card-img"
        src={productImage.url || `${ASSETS}/default/products/Mobile_${random(4, 1)}x2.jpg`}
        alt={name}
      />
      <div className="faculty-deals-card-info">
        <div>
          <h1 className="faculty-deals-card-title heavy">{name}</h1>
          <p className="faculty-deals-card-description">{parse(description.short || '')}</p>
        </div>
        <div>
          <p className="faculty-deals-card-as-low-as">
            {t('Common_asLowAs')}{' '}
            <span className="heavy faculty-deals-card-as-low-as-highlight">
              {getAmountWithCurrency(locale.language, asLowAs.currencyType, asLowAs.price)}
            </span>
          </p>
          <Link
            to={{
              pathname: toPath,
              state: { path: history.location.pathname, search: history.location.search, productName: product.name, locationPath: toPath },
            }}
            title={name || 'Product Description Card'}
            style={{ textDecoration: 'none' }}
            className="faculty-deals-card-button light"
          >
            {t('Common_buyNow')}
          </Link>
        </div>
      </div>
    </div>
  )
}

const FacultyDeals: FC<FacultyDealsProps> = ({ products }) => {
  const { t } = useI18n()
  return (
    <div className="faculty-deals">
      <h1 className="faculty-deals-title heavy">
        {t('Common_greatDealsFor').toUpperCase()} <span className="faculty-deals-title-highlight">{t('Common_faculty').toUpperCase()}</span>
      </h1>
      <div className="faculty-deals-list">
        {products.map((item) => (item ? <FacultyDealsCard key={item?.productId} product={item} /> : null))}
      </div>
    </div>
  )
}

export default FacultyDeals
